<div id="login-page">
    <div id="login-form">
        <!-- <div class="login-form-row"> -->
        <mat-form-field class="login-form-row">
            <input matInput placeholder="Login" type="text" [(ngModel)]="model.username" />
        </mat-form-field>
        <!-- </div> -->
        <mat-form-field class="login-form-row">
            <input matInput placeholder="Hasło" type="password" [(ngModel)]="model.password" #password />
        </mat-form-field>
        <div [style.height.px]="12">
            @if(loginError) {
            <span id="login-error">{{loginError}}</span>
            }
        </div>
        <div class="login-form-row">
            <button matButton id="login-button" (click)="login()">Login</button>
        </div>
    </div>
</div>